import { render, staticRenderFns } from "./contentCorner.vue?vue&type=template&id=f4e0d7ce&scoped=true"
var script = {}
import style0 from "./contentCorner.vue?vue&type=style&index=0&id=f4e0d7ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e0d7ce",
  null
  
)

export default component.exports